/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { currencyFormatter } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { CheckboxComponent } from '../../NDC/component/NDCDetails/CMSDrug/CMSDrugInputContainer';

export default function ClaimFinancial(props) {
  const { claimDetails } = props;
  return (
    <div>
      <fieldset className="custom-fieldset">
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="submitted_amount"
                label="Submitted Amount:"
                className={
                  parseFloat(claimDetails?.financialVO?.submittedAmt) < 0
                    ? 'negative-amt-fld'
                    : ''
                }
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={currencyFormatter(
                  claimDetails?.financialVO?.submittedAmt,
                  '$'
                )}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="ingredient_amount"
                label="Ingredient Amount:"
                className={
                  parseFloat(claimDetails?.financialVO?.ingredientAmt) < 0
                    ? 'negative-amt-fld'
                    : ''
                }
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={currencyFormatter(
                  claimDetails?.financialVO?.ingredientAmt,
                  '$'
                )}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="dispensing_fee"
                label="Dispensing Fee"
                className={
                  parseFloat(claimDetails?.financialVO?.dispensingFee) < 0
                    ? 'negative-amt-fld'
                    : ''
                }
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={currencyFormatter(
                  claimDetails?.financialVO?.dispensingFee,
                  '$'
                )}
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="allowed_amount"
                label="Allowed Amount:"
                className={
                  parseFloat(claimDetails?.financialVO?.allowedAmt) < 0
                    ? 'negative-amt-fld'
                    : ''
                }
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={currencyFormatter(
                  claimDetails?.financialVO?.allowedAmt,
                  '$'
                )}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="copay_amount"
                label="Copay Amount:"
                className={
                  parseFloat(claimDetails?.financialVO?.copayAmt) < 0
                    ? 'negative-amt-fld'
                    : ''
                }
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={currencyFormatter(
                  claimDetails?.financialVO?.copayAmt,
                  '$'
                )}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="tpl_amount"
                label="TPL Amount:"
                className={
                  parseFloat(claimDetails?.financialVO?.tplAmt) < 0
                    ? 'negative-amt-fld'
                    : ''
                }
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={currencyFormatter(
                  claimDetails?.financialVO?.tplAmt,
                  '$'
                )}
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="reimbursement_amount"
                label="Reimbursement Amount:"
                className={
                  parseFloat(claimDetails?.financialVO?.reimbursementAmt) < 0
                    ? 'negative-amt-fld'
                    : ''
                }
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={currencyFormatter(
                  claimDetails?.financialVO?.reimbursementAmt,
                  '$'
                )}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="deductible_amount"
                label="Deductible Amount:"
                className={
                  parseFloat(claimDetails?.financialVO?.deductibleAmt) < 0
                    ? 'negative-amt-fld'
                    : ''
                }
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={currencyFormatter(
                  claimDetails?.financialVO?.deductibleAmt,
                  '$'
                )}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="drug_gross_amount"
                label="Drug Gross Amount:"
                className={
                  parseFloat(claimDetails?.financialVO?.drugGrossAmt) < 0
                    ? 'negative-amt-fld'
                    : ''
                }
                fullWidth
                disabled
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                name="invoiceHandlingCd"
                inputProps={{
                  maxLength: 50,
                }}
                value={currencyFormatter(
                  claimDetails?.financialVO?.drugGrossAmt,
                  '$'
                )}
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="form-wrapper vertical-wrapper">
              <div className="mui-custom-form no-margin min-full-width">
                <div className="sub-radio text-black sub-label">
                  <CheckboxComponent
                    label="Included in Invoice"
                    checked={claimDetails?.financialVO?.invoicedInd == 1}
                    labelPlacement="end"
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="form-wrapper vertical-wrapper">
              <div className="mui-custom-form no-margin min-full-width">
                <div className="sub-radio text-black sub-label">
                  <CheckboxComponent
                    label="Included in Supplemental Invoice"
                    checked={claimDetails?.financialVO?.suppInvoicedInd == 1}
                    labelPlacement="end"
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="non_invoice_reasons"
                label="Non Invoice Reasons:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.financialVO?.nonInvoiceReasonCd}
              />
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 mb-0">
            <div className="form-wrapper vertical-wrapper">
              <div className="mui-custom-form no-margin min-full-width">
                <div className="sub-radio text-black sub-label">
                  <CheckboxComponent
                    label="Claim has been Reversed"
                    checked={
                      claimDetails?.financialVO?.reversingClaimId !== null
                    }
                    labelPlacement="end"
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-4 mb-0">
            <div className="mui-custom-form with-select input-md override-width-95">
              <TextField
                id="supplemental_non_invoice_reason"
                label="Supplemental Non Invoice Reason:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.financialVO?.suppNonInvoiceReasonCd || ''}
              />
            </div>
          </div>
          <div className="col-4 mb-0">
            <div
              className="mui-custom-form with-select input-md override-width-95"
              id="text-color-red"
            >
              <TextField
                id="adjustment_code"
                label="Adjustment Code:"
                fullWidth
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                disabled
                inputProps={{
                  maxLength: 50,
                }}
                value={claimDetails?.financialVO?.adjustmentCd || ''}
              />
            </div>
          </div>
        </div>
        {claimDetails?.financialVO?.prevClaimId ? (
          <div className="row align-items-center">
            <div className="col-4 mb-0">
              <div
                className="mui-custom-form with-select input-md override-width-95"
                id="text-color-red"
              >
                <TextField
                  id="previous_claim_id"
                  label="Previous Claim ID:"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                  inputProps={{
                    maxLength: 50,
                  }}
                  value={claimDetails?.financialVO?.prevClaimId || ''}
                />
              </div>
            </div>
            <div className="col-4 mb-0">
              <div
                className="mui-custom-form with-select input-md override-width-95"
                id="text-color-red"
              >
                <label
                  className="m-0 hide-elm"
                  htmlFor="previous_claim_line_number"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  id="previous_claim_line_number"
                  disabled
                  inputProps={{
                    maxLength: 50,
                  }}
                  value={claimDetails?.financialVO?.prevClaimLineNum || ''}
                />
              </div>
            </div>
          </div>
        ) : null}
        {claimDetails?.financialVO?.reversingClaimId ? (
          <div className="row align-items-center">
            <div className="col-4 mb-0">
              <div
                className="mui-custom-form with-select input-md override-width-95"
                id="text-color-red"
              >
                <TextField
                  id="reversingClaimId"
                  label="Reversing Claim ID:"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                  inputProps={{
                    maxLength: 50,
                  }}
                  value={claimDetails?.financialVO?.reversingClaimId || ''}
                />
              </div>
            </div>
            <div className="col-4 mb-0">
              <div
                className="mui-custom-form with-select input-md override-width-95"
                id="text-color-red"
              >
                <label
                  className="m-0 hide-elm"
                  htmlFor="previous_claim_line_number"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  id="reversingClaimLineNum"
                  disabled
                  inputProps={{
                    maxLength: 50,
                  }}
                  value={claimDetails?.financialVO?.reversingClaimLineNum || ''}
                />
              </div>
            </div>
          </div>
        ) : null}
        {claimDetails?.financialVO?.origClaimId ? (
          <div className="row align-items-center">
            <div className="col-4 mb-0">
              <div
                className="mui-custom-form with-select input-md override-width-95"
                id="text-color-red"
              >
                <TextField
                  id="origClaimId"
                  label="Original Claim ID:"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                  inputProps={{
                    maxLength: 50,
                  }}
                  value={claimDetails?.financialVO?.origClaimId || ''}
                />
              </div>
            </div>
            <div className="col-4 mb-0">
              <div
                className="mui-custom-form with-select input-md override-width-95"
                id="text-color-red"
              >
                <label
                  className="m-0 hide-elm"
                  htmlFor="previous_claim_line_number"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  id="origClaimLineNum"
                  disabled
                  inputProps={{
                    maxLength: 50,
                  }}
                  value={claimDetails?.financialVO?.origClaimLineNum || ''}
                />
              </div>
            </div>
          </div>
        ) : null}
        {claimDetails?.financialVO?.replacingClaimId ? (
          <div className="row align-items-center">
            <div className="col-4 mb-0">
              <div
                className="mui-custom-form with-select input-md override-width-95"
                id="text-color-red"
              >
                <TextField
                  id="replacingClaimId_claim_id"
                  label="Replacement Claim ID:"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                  inputProps={{
                    maxLength: 50,
                  }}
                  value={claimDetails?.financialVO?.replacingClaimId || ''}
                />
              </div>
            </div>
            <div className="col-4 mb-0">
              <div
                className="mui-custom-form with-select input-md override-width-95"
                id="text-color-red"
              >
                <label
                  className="m-0 hide-elm"
                  htmlFor="previous_claim_line_number"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  id="replacingClaimLineNum"
                  disabled
                  inputProps={{
                    maxLength: 50,
                  }}
                  value={claimDetails?.financialVO?.replacingClaimLineNum || ''}
                />
              </div>
            </div>
          </div>
        ) : null}
      </fieldset>
    </div>
  );
}
